<div class="row">
  <div class="col-sm-12">
    <app-card
      [title]="'admin.language.add.information'|translate"
      [cardOptionBtnValue]="'admin.language.delete.button'|translate"
      [cardOptionBtnIcon]="'feather'"
      [cardOptionBtn]="isEdit"
      (outputButton)="showDeleteModal()"
    >
      <app-classic-box #classicForm [classicBox]="classicBox" [data]="lastValue"
                       (changeForm)="enableButton($event)"></app-classic-box>
      <div class="card-block-hid ng-trigger ng-trigger-cardToggle" style="overflow: hidden;">
        <div class="card-block pull-right">
          <button (click)="submitItem(false)" class="btn btn-link" type="button">{{'global.cancel'|translate}}</button>
          <button [disabled]="!enableSave" (click)="submitItem(true)" class="btn btn-primary ripple light" type="button">
            {{(isEdit ? 'admin.language.edit.button' : 'admin.language.add.button') | translate}}</button>
        </div>
      </div>
    </app-card>
  </div>
</div>


<app-modal-basic #deleteModal>
  <div class="app-modal-header">
    <h4 class="modal-title">{{ 'global.soft_delete_title' | translate:{entity: 'Language'} }}</h4>
    <button type="button" class="close basic-close" (click)="deleteModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p>{{ 'global.soft_delete_body' | translate}}: <span [innerHTML]="lastValue.language.name"></span></p>
    <p>{{ 'admin.language.modal.replace.language.info' | translate}}</p>
    <div class="form-group row">
      <div class="col-sm-12">
        <label>{{ 'admin.language.modal.replace.title' | translate}} *</label>
        <ng-select [items]="languages | async"
                   bindLabel="name"
                   [addTag]="false"
                   [hideSelected]="true"
                   [loading]="languageLoading"
                   [typeahead]="languagesinput$"
                   [(ngModel)]="selectedLanguage">
        </ng-select>
      </div>
    </div>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4" (click)="deleteModal.hide()">{{'global.cancel'|translate}}</button>
    <button type="button" class="btn btn-primary ripple light" [disabled]="!selectedLanguage" (click)="softDelete()">{{'global.actions.delete'|translate}}</button>
  </div>
</app-modal-basic>
